import React from 'react';

import PageLayout from '@/components/layout/PageLayout';
import { Card } from '@/components/ui/cards';
import { UpdateShiftDescriptionForm, ShiftWeeklyDistributionGrid } from '@/components/features/shift';
import { useShiftEdit } from '@/hooks/shift/useShiftEdit';
import { useShiftWeeklyDistribution } from '@/hooks/shift/useShiftWeeklyDistribution';
import { useTranslation } from '@/i18n';


export const ShiftEdit: React.FC = () => {
  const { t: translate } = useTranslation('schedule');
  const {
    formSubset,
    shiftCode,
    isLoadingCatalogs,
    workingDayTypeOptions,
    workingDayOptions,
    selectedWorkingDay,
    isDistributedCyclesType,
    isExceptionalType,
    isStaticType,
    weeksCountEditable,
    ordinaryHours,
    isReadOnly,
    canEdit,
    initialDayDetails,
    descriptionValues,
    isEnabled,
    isTogglingStatus,
    onToggleStatus,
    isSaving,
    onSave,
    handleCancel,
    confirmNavigation,
  } = useShiftEdit();

  const weeklyDistribution = useShiftWeeklyDistribution({
    descriptionValues,
    selectedWorkingDay,
    ordinaryHours,
    confirmNavigation,
    initialDetails: initialDayDetails,
    readOnly: isReadOnly,
    onSaveOverride: onSave,
    externalIsSaving: isSaving,
  });

  return (
    // `hideCard`: la Descripción y la Distribución de jornada son dos tarjetas
    // independientes (según diseño), en lugar de una sola tarjeta de PageLayout
    // conteniendo ambas secciones.
    <PageLayout
      isLoading={isLoadingCatalogs}
      dynamicTitle={translate('shift.edit.title')}
      hideCard
    >
      <div data-testid="shift-edit-page">
        {/* `padding=""` neutraliza el padding inline por defecto de Card (8px), que
            de lo contrario gana sobre las clases de Tailwind (mismo patrón que PageLayout). */}
        <Card padding="" className="p-6 md:p-8">
          <UpdateShiftDescriptionForm
            form={formSubset}
            shiftCode={shiftCode}
            workingDayTypeOptions={workingDayTypeOptions}
            workingDayOptions={workingDayOptions}
            isDistributedCyclesType={isDistributedCyclesType}
            isExceptionalType={isExceptionalType}
            isStaticType={isStaticType}
            weeksCountEditable={weeksCountEditable}
            ordinaryHours={ordinaryHours}
            isReadOnly={isReadOnly}
            canEdit={canEdit}
            isEnabled={isEnabled}
            isTogglingStatus={isTogglingStatus}
            onToggleStatus={onToggleStatus}
          />
        </Card>

        <ShiftWeeklyDistributionGrid
          {...weeklyDistribution}
          permissionAction="edit"
          onCancel={handleCancel}
        />
      </div>
    </PageLayout>
  );
};

export default ShiftEdit;
